export const FETCH_SUMMARY_BEHAVIOUR_INIT = 'FETCH_SUMMARY_BEHAVIOUR_INIT';
export const FETCH_SUMMARY_BEHAVIOUR_SUCCESS = 'FETCH_SUMMARY_BEHAVIOUR_SUCCESS';
export const FETCH_SUMMARY_BEHAVIOUR_FAILURE = 'FETCH_SUMMARY_BEHAVIOUR_FAILURE';

export const SET_FILTER_SUMMARY_BEHAVIOUR = 'SET_FILTER_SUMMARY_BEHAVIOUR';
export const RESET_SUMMARY_BEHAVIOUR = 'RESET_SUMMARY_BEHAVIOUR';


// WEBPACK FOOTER //
// ./source/client/actions/summary_behaviour/types.js